import ItemSliding from '../item/src/item.sliding.vue';

ItemSliding.install = function(Vue) {
    Vue.component(ItemSliding.name, ItemSliding);
};

export default ItemSliding;


// WEBPACK FOOTER //
// ./src/components/item-sliding/index.js